import { Tag } from 'antd'
import React, { useRef, useState } from 'react'

interface Props {
    label: React.ReactNode
    closable: boolean
    onClose: (event?: React.MouseEvent<HTMLElement, MouseEvent>) => void
    onDragEnd: () => void
    dndScope: string
}

export const FormSortableSelectTag: React.FC<Props> = ({ label, closable, onClose, onDragEnd, dndScope }) => {
    const [isDragging, setIsDragging] = useState(false)
    const tagRef = useRef<HTMLSpanElement | null>(null)

    const className = `sortable-select-tag draggable-tag${isDragging ? ' dragging-tag' : ''}`

    return (
        <Tag
            ref={tagRef as any}
            draggable
            onDragStart={(e) => {
                e.dataTransfer.effectAllowed = 'move'
                if (tagRef.current) tagRef.current.setAttribute('data-dragging', '1')
                setIsDragging(true)
            }}
            onDragEnd={() => {
                if (tagRef.current) tagRef.current.removeAttribute('data-dragging')
                setIsDragging(false)
                onDragEnd()
            }}
            onMouseDown={(e) => e.stopPropagation()}
            closable={closable}
            onClose={onClose}
            className={className}
            data-dnd-scope={dndScope}
        >
            {label}
        </Tag>
    )
}


// WEBPACK FOOTER //
// ./src/component/app/formSortableSelect/FormSortableSelectTag.tsx